export default "/_next/static/images/e2570fa132b3e0efbe3502a10a16e267.svg";